export const APP_URL = "https://app.connect.bybloomlabs.com/v2/";
export const DOCS_URL = "https://docs.connect.bybloomlabs.com/v2/";
export const STATUS_URL = "https://status.connect.bybloomlabs.com/";

export const MEGA = {
  Features: {
    columns: [
      { heading: "The AI agent", links: [
        { label: "All features", href: "/features/", desc: "Everything in one place" },
        { label: "Media understanding", href: "/features/", desc: "Voice, photo, video, docs" },
        { label: "One-click optimise", href: "/features/", desc: "It rewrites its own instructions" },
      ]},
      { heading: "Channels", links: [
        { label: "All channels", href: "/features/channels/", desc: "Seven live channels" },
        { label: "WhatsApp", href: "/features/channels/whatsapp/", desc: "API and QR" },
        { label: "Instagram DMs", href: "/features/channels/instagram/", desc: "Comment-to-DM" },
      ]},
      { heading: "Platform", links: [
        { label: "API & Webhooks", href: "/developers/", desc: "40+ resources" },
        { label: "MCP server", href: "/developers/mcp/", desc: "Connect Claude, ChatGPT" },
        { label: "Integrations", href: "/integrations/", desc: "Zapier, Make, n8n" },
      ]},
    ],
  },
  "Use Cases": {
    columns: [
      { heading: "By vertical", links: [
        { label: "High-ticket services", href: "/use-cases/high-ticket-service-providers/", desc: "\u20b1300k\u2013\u20b13M deals" },
        { label: "Clinics & med spas", href: "/use-cases/clinics-and-medspas/", desc: "Screen and book consults" },
        { label: "Real estate", href: "/use-cases/real-estate/", desc: "Qualify and book viewings" },
      ]},
      { heading: "More verticals", links: [
        { label: "Ecommerce", href: "/use-cases/ecommerce/", desc: "Cart recovery, product Q&A" },
        { label: "SaaS", href: "/use-cases/saas/", desc: "Inbound demo booking" },
        { label: "All use cases", href: "/use-cases/", desc: "See every vertical" },
      ]},
    ],
  },
  Resources: {
    columns: [
      { heading: "Library", links: [
        { label: "All resources", href: "/resources/", desc: "Playbooks, swipe files, models" },
        { label: "Free tools", href: "/tools/", desc: "54 calculators" },
        { label: "Rankings", href: "/best/", desc: "Honestly ranked in 2026" },
      ]},
      { heading: "Compare", links: [
        { label: "Alternatives", href: "/alternatives/", desc: "Why teams switch" },
        { label: "Changelog", href: "/changelog/", desc: "What shipped recently" },
        { label: "FAQ", href: "/faq/", desc: "Answers to the common questions" },
      ]},
    ],
  },
};

export const FOOTER = [
  { title: "Product", links: [
    { label: "Features", href: "/features/" },
    { label: "Use Cases", href: "/use-cases/" },
    { label: "Alternatives", href: "/alternatives/" },
    { label: "Free Tools", href: "/tools/" },
    { label: "Rankings", href: "/best/" },
    { label: "How It Works", href: "/#how" },
    { label: "Pricing", href: "/pricing/" },
    { label: "Reviews", href: "/reviews/" },
    { label: "FAQ", href: "/faq/" },
  ]},
  { title: "Platform", links: [
    { label: "Channels", href: "/features/channels/" },
    { label: "Integrations", href: "/integrations/" },
    { label: "API & Webhooks", href: "/developers/" },
    { label: "MCP Server", href: "/developers/mcp/" },
    { label: "Security", href: "/security/" },
    { label: "Status", href: STATUS_URL, external: true },
    { label: "Changelog", href: "/changelog/" },
    { label: "Live Demo", href: "/demo/" },
  ]},
  { title: "Resources", links: [
    { label: "All Resources", href: "/resources/" },
    { label: "Playbooks", href: "/resources/?type=playbooks" },
    { label: "Swipe Files", href: "/resources/?type=swipe-files" },
    { label: "Diagnostics", href: "/resources/?type=diagnostics" },
    { label: "High-Ticket DM Methodology", href: "/resources/high-ticket-dm-methodology/" },
    { label: "47 Sales DM Templates", href: "/resources/47-sales-dm-templates/" },
    { label: "Plan Picker", href: "/tools/plan-picker/" },
    { label: "Instagram DM Funnel Audit", href: "/resources/instagram-dm-funnel-audit/" },
  ]},
  { title: "Company", links: [
    { label: "Help Centre", href: DOCS_URL, external: true },
    { label: "Contact", href: "/contact/" },
    { label: "Security", href: "/security/" },
    { label: "Terms", href: "/terms/" },
    { label: "Privacy Policy", href: "/privacy/" },
    { label: "Refund Policy", href: "/refund-policy/" },
    { label: "DPA", href: "/dpa/" },
    { label: "Sub-processors", href: "/subprocessors/" },
    { label: "Contact Sales", href: "/contact/?intent=sales" },
  ]},
];
